"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var useAutoFocus_1 = __importDefault(require("../../utils/useAutoFocus"));
var FormError_1 = __importDefault(require("./FormError"));
var Form_1 = require("./Form");
var useDisabled_1 = __importDefault(require("./useDisabled"));
var Icon_1 = __importDefault(require("../Icon"));
var centsValidator = function (value) {
    if (value && parseFloat(value) <= 0) {
        return "Value must be greater than $0.00";
    }
    return null;
};
var CentsField = function (_a) {
    var autoFocus = _a.autoFocus, children = _a.children, className = _a.className, disabled = _a.disabled, name = _a.name, onChange = _a.onChange, required = _a.required, value = _a.value, icon = _a.icon, props = __rest(_a, ["autoFocus", "children", "className", "disabled", "name", "onChange", "required", "value", "icon"]);
    var _b = Form_1.useForm(), onError = _b.onError, onFormChange = _b.onFormChange, submitted = _b.submitted, values = _b.values;
    var inputRef = react_1.useRef(null);
    var _c = react_1.useState(false), touched = _c[0], setTouched = _c[1];
    useAutoFocus_1.default(autoFocus, inputRef);
    useDisabled_1.default(name, disabled);
    var onBlur = function () { return setTouched(true); };
    var handleChange = function (event) {
        var nextValue = event.target.value;
        var amount = nextValue ? Math.round(parseFloat(nextValue) * 100) : null;
        if (onChange) {
            onChange(amount);
        }
        onFormChange(name, amount);
    };
    var normal = value || values[name];
    return (react_1.default.createElement("label", { className: classnames_1.default("chq-ffd", className), htmlFor: name },
        react_1.default.createElement("span", { className: "chq-ffd--lb" }, children),
        react_1.default.createElement("span", { className: "chq-ffd--ad" }, icon ? (react_1.default.createElement(Icon_1.default, { icon: icon })) : (react_1.default.createElement(react_1.default.Fragment, null, "$"))),
        react_1.default.createElement("input", __assign({ className: "chq-ffd--ctrl", ref: inputRef }, props, { disabled: disabled, type: "number", id: name, name: name, min: "0", step: ".01", value: typeof normal === "number" ? normal / 100 : "", onBlur: onBlur, onChange: handleChange })),
        react_1.default.createElement(FormError_1.default, { name: name, onError: onError, required: required, submitted: submitted, touched: touched, validator: centsValidator, value: normal })));
};
exports.default = CentsField;
